import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { MdCheck, MdClose } from 'react-icons/md';
import { StructuredContentRenderer } from '../StructuredContentRenderer';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
};

export function DefaultProsAndCons({ prosList, consList }: Props) {
  const hasPros = !!prosList?.length;
  const hasCons = !!consList?.length;

  if (!hasPros && !hasCons) return null;

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: { base: 'column', sm: 'row' },
        columnGap: '7',
        rowGap: '7',
      })}
    >
      {hasPros && (
        <div
          className={css({
            flexGrow: '[1]',
            flexShrink: '[1]',
            flexBasis: '[0%]',
          })}
        >
          <h2
            className={css({
              display: 'block',
              textStyle: 'textLargeBold',
              borderBottomWidth: 'medium',
              borderBottomStyle: 'solid',
              borderBottomColor: 'green.main',
              marginBottom: '2',
              paddingBottom: '1',
            })}
          >
            Pros
          </h2>
          <ul
            className={css({
              listStyleType: 'disc',
              paddingTop: '0',
              paddingRight: '0',
              paddingBottom: '0',
              paddingLeft: '0',
            })}
          >
            {prosList.map((bullet, index) => (
              <li
                key={`pro-${index}`}
                className={css({
                  paddingBlockStart: '1',
                  paddingBlockEnd: '1',
                  paddingInlineStart: '0',
                  paddingInlineEnd: '0',
                  display: 'flex',
                  alignItems: 'flex-start',
                  columnGap: '2',
                  rowGap: '2',
                })}
              >
                <MdCheck
                  className={css({ color: 'green.main', width: '[22px]', height: '[22px]' })}
                />
                {typeof bullet === 'string' ? (
                  <span>{bullet}</span>
                ) : (
                  <StructuredContentRenderer doc={bullet} />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      {hasCons && (
        <div
          className={css({
            flexGrow: '[1]',
            flexShrink: '[1]',
            flexBasis: '[0%]',
          })}
        >
          <h2
            className={css({
              display: 'block',
              textStyle: 'textLargeBold',
              borderBottomWidth: 'medium',
              borderBottomStyle: 'solid',
              borderBottomColor: 'red.main',
              marginBottom: '2',
              paddingBottom: '1',
            })}
          >
            Cons
          </h2>
          <ul
            className={css({
              listStyleType: 'disc',
              paddingTop: '0',
              paddingRight: '0',
              paddingBottom: '0',
              paddingLeft: '0',
            })}
          >
            {consList.map((bullet, index) => (
              <li
                key={`con-${index}`}
                className={css({
                  paddingBlockStart: '1',
                  paddingBlockEnd: '1',
                  paddingInlineStart: '0',
                  paddingInlineEnd: '0',
                  display: 'flex',
                  alignItems: 'flex-start',
                  columnGap: '2',
                  rowGap: '2',
                })}
              >
                <MdClose
                  className={css({ color: 'red.main', width: '[22px]', height: '[22px]' })}
                />
                {typeof bullet === 'string' ? bullet : <StructuredContentRenderer doc={bullet} />}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
